module.exports = __webpack_public_path__ + "assets/img/img_2_8_1.0e101318.png";